import React from "react";
import { Link } from "react-router-dom";

function HomePageFaqs() {
  const FAQs = [
    {
      question: "What makes Algoturtle unique?",
      answer:
        "India's first AI-based algo trading platform. Develop your own strategies with us or use one of our own. Strategies available for every market condition, trending or sideways. Expiry Special (CAP) (Nifty) Amazing strategies. Unique UI.",
    },
    {
      question: "What is Algoturtle?",
      answer:
        "Algoturtle is India's first AI-based algorithmic trading platform.",
    },
    {
      question: "Why choose Algoturtle?",
      answer:
        "Trade like never before. Trade without emotions. Stress-free, systematic, and disciplined.",
    },
    {
      question: "Can I customize/develop strategies?",
      answer:
        "Of course YOU CAN. We specialize in custom strategies. Custom strategies are one of our higher-selling products.",
    },
    {
      question: "How do I get started?",
      answer: "Register here, and our team will contact you. REGISTER NOW.",
    },
  ];

  const getRandomLightColor = () => {
    const colors = [
      "bg-blue-100",
      "bg-green-100",
      "bg-yellow-100",
      "bg-pink-100",
      "bg-purple-100",
    ];
    return colors[Math.floor(Math.random() * colors.length)];
  };

  return (
    <div className="faq--container py-12 px-4 sm:px-6 lg:px-8">
      <h1 className="text-center text-4xl font-extrabold text-gray-800 mb-10">
        Frequently Asked Questions
      </h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {FAQs.map((faq, index) => (
          <div
            key={index}
            className={`card-faq p-6 rounded-lg shadow-md ${getRandomLightColor()} transition-transform transform hover:scale-105`}
          >
            <h4 className="text-lg font-semibold text-gray-800 mb-2">
              {faq.question}
            </h4>
            <p className="text-gray-600">{faq.answer}</p>
          </div>
        ))}
      </div>
      <div className="mt-8 text-center">
        <Link
          to="/faqs"
          className="inline-block bg-blue-600 text-white px-6 py-3 rounded-lg shadow-md hover:bg-blue-700 transition-colors"
        >
          View all
        </Link>
      </div>
    </div>
  );
}

export default HomePageFaqs;
